import loadable from '@loadable/component';
import { PageLoading } from "@tawn33y/gigsflow-core";

const Terms = loadable(() => import('@tawn33y/gigsflow-core/dist/pages/Terms/Terms'), {
  resolveComponent: (components) => components.Terms,
  fallback: (
    <PageLoading
      title="Terms of Use"
      description='These Legal Terms constitute a legally binding agreement made between you, whether personally or on behalf of an entity ("you"), and Gigsflow, concerning your access to and use of the Services'
      url="https://gisflow.com/terms"
    />
  ),
});

export default function TermsPage() {
  return <Terms />
}
